import { SVGProps } from 'react'

type QuestionIconProps = SVGProps<SVGSVGElement>

const QuestionIcon = ({ className, ...props }: QuestionIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.924 3.075A10.472 10.472 0 0 0 10.5 0a10.472 10.472 0 0 0-7.425 3.075A10.472 10.472 0 0 0 0 10.5c0 2.896 1.177 5.528 3.075 7.425A10.473 10.473 0 0 0 10.5 21c2.896 0 5.528-1.177 7.424-3.075A10.472 10.472 0 0 0 21 10.5c0-2.896-1.177-5.528-3.076-7.425Zm-1.54 1.54a8.292 8.292 0 0 1 2.438 5.885c0 2.302-.93 4.375-2.437 5.885a8.291 8.291 0 0 1-5.885 2.437 8.291 8.291 0 0 1-5.885-2.437A8.291 8.291 0 0 1 2.178 10.5c0-2.302.93-4.375 2.437-5.885A8.29 8.29 0 0 1 10.5 2.178c2.302 0 4.375.93 5.885 2.437Z"
    />
    <path
      fill="currentColor"
      d="M9.957 13.508a1.055 1.055 0 1 0 0 2.11 1.055 1.055 0 0 0 0-2.11ZM7.562 7.13l.718.576a.388.388 0 0 0 .497-.01s.088-.16.365-.318c.278-.157.638-.283 1.177-.285.47 0 .88.175 1.16.414a1.3 1.3 0 0 1 .307.374c.064.122.087.23.087.311a1.288 1.288 0 0 1-.132.609 1.23 1.23 0 0 1-.235.314 2.632 2.632 0 0 1-.572.41c-.225.126-.467.238-.712.373-.28.155-.575.377-.794.71-.109.165-.194.354-.248.553-.055.2-.08.408-.08.621v.414c0 .214.174.388.389.388h.934a.388.388 0 0 0 .388-.388v-.414c0-.082.01-.135.019-.168a.207.207 0 0 1 .05-.094.662.662 0 0 1 .173-.126c.14-.079.365-.185.62-.324.383-.209.848-.492 1.24-.96a2.86 2.86 0 0 0 .486-.84 3.1 3.1 0 0 0 .184-1.078c0-.395-.107-.771-.282-1.104a3.117 3.117 0 0 0-1.186-1.22 3.533 3.533 0 0 0-1.796-.485c-.824-.003-1.509.213-2.026.51-.519.296-.742.641-.742.641a.39.39 0 0 0 .01.597Z"
    />
  </svg>
)
export default QuestionIcon
